import { useAuthStore } from '@/store/auth'
import { redirect } from '@tanstack/react-router'
import { UserRole } from '@depanneo/types'

export const requiredRoles = (allowedRoles: UserRole[]) => {
  const { role } = useAuthStore.getState()

  if (!role) throw redirect({ to: '/unauthorized' })

  if (role === UserRole.SUPER_ADMIN) return

  if (!allowedRoles.includes(role)) {
    throw redirect({ to: '/unauthorized' })
  }
}
